import { BaseEntityInfoUtils, EntityInfo } from '@record-it-npm/synchro-common';
import { AppCommonSynchronizationEnvironmentTypes } from '../../../AppCommonSynchronizationEnvironment';
import { EntityName } from '../../../EntityName';
import { CreateEntityInfoOptions } from '../../base/CreateEntityInfoOptions';
import { UserGroupSubEntityInfoUtils } from '../../base/UserGroupSubEntityInfoUtils';
import { WorkTimeEntryDto } from './WorkTimeEntryDto';
export function createWorkTimeEntryEntityInfo<TEntity extends WorkTimeEntryDto>(options: CreateEntityInfoOptions<WorkTimeEntryDto, TEntity>): EntityInfo<AppCommonSynchronizationEnvironmentTypes, EntityName.WorkTimeEntry, TEntity> {
  return {
    entityName: EntityName.WorkTimeEntry,
    synchronizeRelativeTo: [],
    trackGlobalRevision: true,
    fieldInfos: BaseEntityInfoUtils.createFieldInfos<AppCommonSynchronizationEnvironmentTypes, WorkTimeEntryDto, TEntity>({
      ...UserGroupSubEntityInfoUtils.createBaseFieldInfos(),
      startDate: {
        name: 'startDate'
      },
      endDate: {
        name: 'endDate'
      },
      note: {
        name: 'note'
      },
      userId: {
        name: 'userId',
        ref: EntityName.User
      },
      constructionSiteId: {
        name: 'constructionSiteId',
        ref: EntityName.ConstructionSite,
        defaultValue: null
      },
      timeTrackingActivityId: {
        name: 'timeTrackingActivityId',
        ref: EntityName.TimeTrackingActivity,
        defaultValue: null
      },
      breaks: {
        name: 'breaks',
        defaultValue: () => [],
        innerInfo: [{
          endDate: {
            name: 'endDate'
          },
          index: {
            name: 'index'
          },
          startDate: {
            name: 'startDate'
          }
        }]
      }
    }, options.additionalFieldInfos)
  };
}